import React from 'react'

function FromPropByDynamicName() {
    return (
        <span className='cs-exp-read-prop-dynamic-name'>By dynamic name ( expression ) / array index</span>
    )
}

export { FromPropByDynamicName }